// 仪器管理路由
import Layout from '@/layout'

const personRoute = [
    {
        path: '/personManagement',
        component: Layout,
        redirect: '/personManagement/personList',
        name: 'personManagement',
        meta: {
          title: '人员管理',
          icon: 'renyuanguanli',
          roles: ['manager']
        },
        children: [
          {
            path: 'personList',
            component: () => import('@/views/personManagement/personList'),
            name: 'personList',
            meta: {
              title: '人员列表',
              icon: 'employee'
            }
          },
          {
            path: 'add-authorized-person',
            component: () => import('@/views/process/authorizedPerson/add'),
            name: 'addAuthorizedPerson',
            meta: {
              title: '人员授权【申请】',
              icon: 'yiqi'
            }
          },
          {
            path: "authorizedPerson",
            component: () => import("@/views/taskCenter/authorizedPerson/index"),
            name: "authorizedPerson",
            meta: {
              title: "人员授权【审批】",
              icon: "check-result",
            },
          },
          {
            path: 'addPerson',
            name: 'AddPerson',
            component: () => import('@/views/personManagement/addPerson/index'),
            meta: {
              title: '添加人员',
              icon: 'user',           
              noCache: true
            },
            hidden: true,

          },
          {
            path: 'editPerson/:id',
            name: 'editPerson',
            component: () => import('@/views/personManagement/addPerson/index'),
            meta: {
              title: '人员编辑',
              icon: 'usert'
            },
            hidden: true
          },
          {
            path: "view-authorized-person",
            component: () => import("@/views/process/authorizedPerson/add"),
            name: "viewAuthorizedPerson",
            meta: {
              title: "查看-人员授权审批",
              icon: "yiqi",
              noCache: true
            },
            hidden:true
          },
          {
            path: "approval-authorized-person",
            component: () => import("@/views/process/authorizedPerson/add"),
            name: "approvalAuthorizedPerson",
            meta: {
              title: "审批-人员授权审批",
              icon: "yiqi",
              noCache: true
            },
            hidden:true
          },
        ]
      }
]
export default personRoute



// WEBPACK FOOTER //
// ./src/router/modules/personManagement.js